

Ctrl.$inject = ['$scope', 'PortalApi']
function Ctrl($scope, PortalApi) {

	
}

module.exports = Ctrl;


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/myPayments/controllers/mypayments.js
 ** module id = 276
 ** module chunks = 1
 **/